// extracted by mini-css-extract-plugin
export default {"spinner":"ppzo8JfOq78OrAOh7oxQ","spen":"Vlo4CJr8ZlXwtgH6OKl6"};